import { render, staticRenderFns } from "./MobileSalePoint.vue?vue&type=template&id=dbbbe9dc&scoped=true&lang=pug&"
import script from "./MobileSalePoint.vue?vue&type=script&lang=js&"
export * from "./MobileSalePoint.vue?vue&type=script&lang=js&"
import style0 from "./MobileSalePoint.vue?vue&type=style&index=0&id=dbbbe9dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbbe9dc",
  null
  
)

component.options.__file = "MobileSalePoint.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
  VLayout,
  VSnackbar,
})
